var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppHome = function SvgAppHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.7V19h-6v-6H9v6H3V9.7l-1.65 1.65-.7-.7L10 1.3l9.35 9.35-.7.7L17 9.7zm-13-1V18h4v-6h4v6h4V8.7l-6-6-6 6z",
    fillRule: "evenodd"
  })));
};
export default SvgAppHome;